import {Component} from '@angular/core';
import {LocaleService} from '../../../services/locale.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent {
  locales = this.localeService.availableLocales() as { code: string; label: string; countryCode: string }[];
  current = this.localeService.getLocale();

  constructor(private localeService: LocaleService) {}

  select(code: string): void {
    if (code !== this.current) {
      this.localeService.setLocale(code);
    }
  }
}
